module.exports = __webpack_public_path__ + "img/loginPic1.0ac2bd4d.png";